<template>
  <div class="shape-options-setting-dialog">
    <div class="content-group-default">
      <el-collapse v-model="activeNames" style="width: 100%">
        <controlWidthAndSizeAndZindex :options="options" :ids="ids" />
        <el-collapse-item @mousedown.native="collapseMouseDown(collapseActiveNames, $event, '2')" title="外观" name="2">
          <div class="content" v-if="collapseActiveNames.length !== 0 && collapseActiveNames.find(it => it === '2')">
            <div class="content-item">
              <slider-and-input :value.sync="opacity" title="透明度" :sliderMax="100" suffix="%" />
            </div>
            <widthAndSizeAndZindex
              :options="options"
              :ids="ids"
              showSetItem="rotate"
              cxMore
              class="mt16"
              v-if="request_prefix !== 'bigScreen'"
            />
            <collapsibleItem class="" v-for="(colorItem, index) in shapeColor" :key="index">
              <div slot="heading">形状{{ index + 1 }}</div>
              <div slot="body" class="bar-color-sets">
                <div class="inlineMiddle mb16">
                  <span class="mr16">角度</span>
                  <el-radio-group v-model="bgAngleValue[index]">
                    <el-radio label="0°">0°</el-radio>
                    <el-radio label="45°">45°</el-radio>
                    <el-radio label="90°">90°</el-radio>
                  </el-radio-group>
                </div>
                <chart-color-setting title="形状颜色" :color.sync="shapeColor[index]" />
                <chart-color-setting title="边框颜色" :color.sync="shapeBorderColor[index]" class="mt16" />
              </div>
            </collapsibleItem>
          </div>
        </el-collapse-item>
        <el-collapse-item @mousedown.native="collapseMouseDown(collapseActiveNames, $event, '3')" title="背景" name="3">
          <div v-if="collapseActiveNames.length !== 0 && collapseActiveNames.find(it => it === '3')">
            <cx-background :background.sync="background" imgType="10" />
            <div class="content-item mt16">
              <div class="checkbox_colorPicker_container">
                <span>阴影</span>
                <span class="icon-portal-plus theme-color right-icon" @click="addBoxshadow"></span>
              </div>
              <box-shadow
                :boxShadowH.sync="boxShadowH"
                :boxShadowV.sync="boxShadowV"
                :boxShadowBlur.sync="boxShadowBlur"
                :boxShadowSpread.sync="boxShadowSpread"
                :boxShadowColor.sync="boxShadowColor"
              ></box-shadow>
            </div>
          </div>
        </el-collapse-item>
        <el-collapse-item
          @mousedown.native="collapseMouseDown(collapseActiveNames, $event, '4')"
          title="图标样式"
          name="4"
        >
          <div
            class="content-item"
            v-if="collapseActiveNames.length !== 0 && collapseActiveNames.find(it => it === '4')"
          >
            <img-icon-upload class="mb16" :imgSrc.sync="iconSrc" iconType="icon" :iconColor.sync="iconColor"  :iconType.sync="iconType"/>
            <div class="content-item mb16 verticallyCenter">
              <span class="mr16 fs14">位置</span>
              <el-radio-group v-model="iconPosition">
                <el-radio label="left">左</el-radio>
                <el-radio label="right">右</el-radio>
              </el-radio-group>
            </div>
            <div class="verticallyCenter mb16" v-if="options.pluginTag !== 'routerNav'">
              <span class="mr16 fs14">颜色</span>
              <color-picker-theme-color
                class="flex1"
                :isThemeColor.sync="iconColorIsThemeColor"
                :color.sync="iconColor"
              >
              </color-picker-theme-color>
            </div>

            <slider-and-input class="mb16" :value.sync="iconSize" title="大小" :sliderMax="sliderMax" suffix="px" />
          </div>
        </el-collapse-item>
      </el-collapse>
    </div>
  </div>
</template>

<script>
import widthAndSizeAndZindex from "publicSetting/widthAndSizeAndZindex.vue"
import controlWidthAndSizeAndZindex from "publicSetting/controlWidthAndSizeAndZindex.vue"
import CxBackground from "modules/components/cxBackground"
import { withMethodsHistoryCombine } from "utils/revork"
export default withMethodsHistoryCombine({
  name: "text-options-data",
  components: { CxBackground, widthAndSizeAndZindex, controlWidthAndSizeAndZindex },
  props: { options: Object },
  data() {
    return {
      collapseActiveNames: ["1", "2", "3", "6"],
      activeNames: ["1", "2", "3", "6"],
      allCollapseNames: ["4"],
      hoverOpt: [],
      this1: this,
      activeType: 1,
      sliderMax: 360,
      borderStyleList: [
        {
          value: "solid",
          label: "实线",
          title: "",
          src: require("assets/images/solid-1.png")
        },
        {
          value: "dashed",
          label: "虚线",
          title: "",
          src: require("assets/images/dashed-1.png")
        },
        {
          value: "dotted",
          label: "点线",
          title: "",
          src: require("assets/images/dotted-1.png")
        }
      ],
      isActive: true
    }
  },
  comments: {},
  created() {},
  mounted() {
    this.$collapseControl({
      allCollapseNames: this.allCollapseNames,
      collapseActiveNames: this.collapseActiveNames,
      activeNames: this.activeNames
    })
  },
  computed: {
    iconPosition: {
      get() {
        return this.options.iconPosition
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "iconPosition", false)
      }
    },
    iconSrc: {
      get() {
        console.log("this.options :>> ", this.options)
        return this.options.iconSrc
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "iconSrc", false)
      }
    },
    iconType: {
      get() {
        return this.options.iconType
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "iconType", false)
      }
    },
    iconSize: {
      get() {
        return this.options.width
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "width", false)
        this.$changeOptionsEV(newVal, "height", false)
      }
    },
    iconHeight: {
      get() {
        return this.options.height
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "height", false)
      }
    },

    iconColor: {
      get() {
        return this.options.iconColor || ""
      },
      set(newVal) {
        // console.log(newVal);
        this.$changeOptionsEV(newVal, "iconColor", false)
      }
    },
    iconColorIsThemeColor: {
      get() {
        return this.options.iconColorIsThemeColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "iconColorIsThemeColor", false)
      }
    },
    ids() {
      return this.$store.state.states.activeID
    },
    activeRect() {
      // this.options();
      let ids = this.$store.state.states.activeID
      if (ids !== null) {
        this.container_id = ids.container_id
        this.rect_id = ids.rect_id
        return this.$store.state.states.activeID
      } else return null
    },

    borderChecked: {
      get() {
        return this.options.borderChecked
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderChecked", false)
      }
    },
    background: {
      get() {
        let background = this.options.background
        if (background && Array.isArray(background) && background.length > 0) {
          return this.options.background
        }
        let newBackground = []
        if (this.bgType === "线性渐变") {
          newBackground.push({
            type: "linearGradient",
            label: "线性渐变",
            data: {
              angle: this.bgColorlinearGradientAngle,
              stops: [
                [this.bgStartColor, 0],
                [this.bgEndColor, 1]
              ]
            }
          })
        }
        if (this.bgType === "径向渐变") {
          newBackground.push({
            type: "radialGradient",
            label: "径向渐变",
            data: {
              siteX: 50,
              siteY: 50,
              stops: [
                [this.bgStartColor, 0],
                [this.bgEndColor, 1]
              ]
            }
          })
        }
        newBackground.push({
          type: "color",
          label: "颜色",
          isThemeColor: false,
          color: this.bgType === "纯色" ? this.bgColor : "rgba(0,0,0,0)"
        })
        this.$changeOptionsEV(newBackground, "background", false, false, false, true)
        return newBackground
      },
      set(val) {
        this.$changeOptionsEV(val, "background", false)
      }
    },
    bgType: {
      get() {
        return this.options.bgType || "纯色"
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "bgType", false)
      }
    },
    bgColor: {
      get() {
        return this.options.bgColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "bgColor", false)
      }
    },
    bgStartColor: {
      get() {
        return this.options.bgStartColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "bgStartColor", false)
      }
    },
    bgEndColor: {
      get() {
        return this.options.bgEndColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "bgEndColor", false)
      }
    },
    borderType: {
      get() {
        return this.options.borderType || "纯色"
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderType", false)
      }
    },
    borderWidth: {
      get() {
        return this.options.borderWidth
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderWidth", false)
      }
    },
    borderColor: {
      get() {
        return this.options.borderColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderColor", false)
      }
    },
    borderStyle: {
      get() {
        return this.options.borderStyle
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderStyle", false)
      }
    },
    opacity: {
      get() {
        return this.options.hasOwnProperty("opacity") ? this.options.opacity : 100
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "opacity", false)
      }
    },
    shapeColor: {
      get() {
        return this.options.hasOwnProperty("shapeColor") && this.options.shapeColor ? this.options.shapeColor : []
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "shapeColor", false)
      }
    },
    boxShadowColor: {
      get() {
        return this.options.hasOwnProperty("boxShadowColor") ? this.options.boxShadowColor : ["rgba(255,255,255,1)"]
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "boxShadowColor", false)
      }
    },
    boxShadowH: {
      get() {
        return this.options.hasOwnProperty("boxShadowH") ? this.options.boxShadowH : 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "boxShadowH", false)
      }
    },
    boxShadowV: {
      get() {
        return this.options.hasOwnProperty("boxShadowV") ? this.options.boxShadowV : 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "boxShadowV", false)
      }
    },
    boxShadowBlur: {
      get() {
        return this.options.hasOwnProperty("boxShadowBlur") ? this.options.boxShadowBlur : 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "boxShadowBlur", false)
      }
    },
    boxShadowSpread: {
      get() {
        return this.options.hasOwnProperty("boxShadowSpread") ? this.options.boxShadowSpread : 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "boxShadowSpread", false)
      }
    },
    bgAngleValue: {
      get() {
        return this.options.hasOwnProperty("bgAngleValue") ? this.options.bgAngleValue : []
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "bgAngleValue", false)
      }
    },
    shapeBorderColor: {
      get() {
        return this.options.hasOwnProperty("shapeBorderColor") ? this.options.shapeBorderColor : []
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "shapeBorderColor", false)
      }
    }
  },
  methods: {
    checkboxHandle(flag) {
      switch (flag) {
        case 1:
          this.shapeType = "square"
          this.borderTopLeftRadius = 0
          this.borderTopRightRadius = 0
          this.borderBottomLeftRadius = 0
          this.borderBottomRightRadius = 0
          break
        case 2:
          if (!this.borderChecked) {
            this.borderColor = "#FFFFFF"
            this.borderWidth = 0
            this.borderStyle = "solid"
          } else {
            this.borderColor = "#FFFFFF"
            this.borderWidth = 1
            this.borderStyle = "solid"
          }
          break
        case 3:
          this.boxShadowColor = "#FFFFFF"
          this.boxShadowH = 0
          this.boxShadowV = 0
          this.boxShadowBlur = 0
          this.boxShadowSpread = 0
          break
        case 4:
          this.rotate = "0deg"
          break
      }
    },
    addBoxshadow() {
      if (!Array.isArray(this.boxShadowH) || !Array.isArray(this.boxShadowColor)) {
        this.boxShadowH = [this.boxShadowH]
        this.boxShadowV = [this.boxShadowV]
        this.boxShadowBlur = [this.boxShadowBlur]
        this.boxShadowSpread = [this.boxShadowSpread]
        this.boxShadowColor = [this.boxShadowColor]
      }
      let boxShadowH = JSON.parse(JSON.stringify(this.boxShadowH))
      let boxShadowV = JSON.parse(JSON.stringify(this.boxShadowV))
      let boxShadowBlur = JSON.parse(JSON.stringify(this.boxShadowBlur))
      let boxShadowSpread = JSON.parse(JSON.stringify(this.boxShadowSpread))
      let boxShadowColor = JSON.parse(JSON.stringify(this.boxShadowColor))
      boxShadowH.push(0)
      boxShadowV.push(4)
      boxShadowBlur.push(4)
      boxShadowSpread.push(0)
      boxShadowColor.push("rgba(0,0,0,0.25)")
      this.boxShadowH = boxShadowH
      this.boxShadowV = boxShadowV
      this.boxShadowBlur = boxShadowBlur
      this.boxShadowSpread = boxShadowSpread
      this.boxShadowColor = boxShadowColor
    }
  }
})
</script>

<style scoped lang="scss">
p {
  margin-bottom: 0;
}
::v-deep .shape-bg-color .el-radio__label {
  padding-left: 4px;
}
.color-picker-container.custom-shape-bg {
  display: inline-block;
  vertical-align: middle;
  width: calc(100% - 80px);
}
</style>
